import { Link } from "react-router-dom";
import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
export default function HomeAbout(){
	const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(!isOpen);
    return(

        <section id="about" className="about-us-area pt-155 pb-120 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30">

			<div className="container">
				<div className="row">
					<ModalVideo channel='youtube' isOpen={isOpen} videoId='lTxn2BuqyzU' onClose={() => { openModal(); }} />
					<div className="col-lg-6">
						<div className="about-video-wrapper mb-30">							
							<a className="popup-video" onClick={() => { openModal(); }}><i className="fa fa-play"></i></a>
							<img className="img-one" src="assets/img/about/about-1.jpg" alt="About Img" />
							<img className="img-two" src="assets/img/about/about-2.jpg" alt="About Img" />
						</div>
					</div>
					<div className="col-lg-6">
						<div className="about-text-wrapper mb-30">
							<h2 className="style-text">About</h2>
							<h6 className="semi-title title-line">About Company</h6>
							<h2 className="sect-title">We provide digital experience services</h2>
							<div className="quote-paragraph">
								<p className="paragraph-title">We help our clients succeed by creating brand identities,
									digital experiences, and print materials.</p>
								<h6>Alonso D. Wilimton <span>-Head Of Idea </span></h6>
							</div>
							<ul className="service-box">
								<li>
									<div className="box-one">
										<div className="icon-a1">
											<img src="assets/img/icon/a-1.png" alt="a-icon" />
										</div>
										<h4 className="sub-title">Website<br /> Analytics</h4>
									</div>
								</li>
								<li>
									<div className="box-one">
										<div className="icon-a1">
											<img src="assets/img/icon/a-1a.png" alt="a-icon" />
										</div>
										<h4 className="sub-title">Boost Your<br />
											Website</h4>
									</div>
								</li>
							</ul>
							<Link to="/services" className="theme_btn">Our Services</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
    )
}